import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Formik } from "formik";
import * as Yup from "yup";
import SelectionAcademicYears from "../../components/selectionAcademicYears";
import { authorizedAPIs } from "../../API/axiosSetup";
import { showAlert } from "../../Redux/actions/viewAlert";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";

export default function EditAssistant() {
  const dispatch = useDispatch();
  const { _id } = useParams();
  const navigate = useNavigate();

 
  const [inputsData, setInputsData] = useState({});

  useEffect(() => {
    authorizedAPIs
      .get(`/user/getOne/${_id}`)
      .then((res) => {
        console.log({ res });
        setInputsData({ ...res.data });
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, []);

  return (
    <>
      <Typography
        style={{ fontSize: "30px", color: "#010004", textAlign: "center" }}
      >
        تعديل مساعد
      </Typography>
      <Formik
        enableReinitialize={true}
        initialValues={{
          fullName: inputsData.fullName,
          phoneNumber: inputsData.phoneNumber,
          parentphoneNumber: inputsData.parentphoneNumber,
          academicYear: inputsData.academicYear,
          email: inputsData.email,
          password: inputsData.password,
        }}
        validationSchema={Yup.object().shape({
          fullName: Yup.string()
            .required("يجب تدخيل الاسم")
            .min(2, "too Short")
            .max(100, "Too Long"),
          email: Yup.string()
            .email("ادخل ايميل صحيح")
            .max(255)
            .required("يجب تدخيل الايميل"),
          password: Yup.string()
            .min(8, "كلمه السر يجب ان تكون اكثر من 8 حروف")
            .max(255)
            .required("يجب تدخيل كلمه السر"),

          phoneNumber: Yup.string().required("يجب تدخيل رقم التليفون"),
        })}
        onSubmit={(values, { resetForm }) => {
          console.log(values);
          authorizedAPIs
            .put(`/user/edit_assistant/${_id}`, values)
            .then((res) => {
              console.log(res);
              dispatch(showAlert("تم تعديل المساعد بنجاح", "success"));
              resetForm();
              navigate("/assistant");
            })
            .catch((err) => {
              console.log(err.message);
            });
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => (
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1, maxWidth: 600, margin: "auto" }}
          >
            <Grid item xs={12}>
              <TextField
                fullWidth
                error={Boolean(touched.fullName && errors.fullName)}
                helperText={touched.fullName && errors.fullName}
                label="الاسم"
                margin="normal"
                name="fullName"
                onBlur={handleBlur}
                onChange={handleChange}
                type="fullName"
                value={values.fullName}
                variant="outlined"
                disabled={isSubmitting}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                error={Boolean(touched.email && errors.email)}
                fullWidth
                helperText={touched.email && errors.email}
                label=" الايميل"
                margin="normal"
                name="email"
                onBlur={handleBlur}
                onChange={handleChange}
                type="email"
                value={values.email}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                error={Boolean(touched.phoneNumber && errors.phoneNumber)}
                fullWidth
                helperText={touched.phoneNumber && errors.phoneNumber}
                label="تليفون الطالب"
                margin="normal"
                name="phoneNumber"
                onBlur={handleBlur}
                onChange={handleChange}
                type="string"
                value={values.phoneNumber}
                variant="outlined"
                disabled={isSubmitting}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                id="outlined-multiline-static"
                error={Boolean(touched.password && errors.password)}
                fullWidth
                helperText={touched.password && errors.password}
                label="الرقم السري"
                margin="normal"
                name="password"
                onBlur={handleBlur}
                onChange={handleChange}
                type="string"
                value={values.password}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              disabled={isSubmitting}
            >
              تعديل المساعد
            </Button>
          </Box>
        )}
      </Formik>
    </>
  );
}
